import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'pnk-datepicker-topnav',
  styleUrl: 'pnk-datepicker-topnav.css',
})
export class PnkDatePickerTopnav {
  @Prop() disabled: boolean = false;

  @Prop() date: Date = new Date();

  @Prop() dateChange!: (date: Date) => void;

  @Prop() toggleView!: () => void;

  @Prop() renderDate: () => void | undefined = () => undefined;

  render() {
    return [
      <pnk-datepicker-nav
        disabled={this.disabled}
        class=" pnk-text-black"
        dateChange={this.dateChange}
        toggleView={() => this.toggleView()}
        renderDate={this.renderDate}
        format="DD/MM/YYYY"
        currentDate={this.date}
      ></pnk-datepicker-nav>,
    ];
  }
}
